export const IconOrganization = ({
  stroke = "var(--color-black)",
  className,
}: {
  stroke?: string;
  className: string;
}) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.7 17H3.15C1.72 17 1 16.28 1 14.85V3.15C1 1.72 1.72 1 3.15 1H7.45C8.88 1 9.6 1.72 9.6 3.15V5M12.4 5V3.15C12.4 1.72 13.12 1 14.55 1H18.85C20.28 1 21 1.72 21 3.15V14.85C21 16.28 20.28 17 18.85 17H16.37M9 10H13M9 13H13M11 21V18M16.37 7.42V18.58C16.37 20.19 15.57 21 13.96 21H8.12C6.51 21 5.7 20.19 5.7 18.58V7.42C5.7 5.81 6.51 5 8.12 5H13.96C15.57 5 16.37 5.81 16.37 7.42Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDropdownArrow = ({
  stroke = "var(--color-gray-70)",
  className,
}: {
  stroke?: string;
  className?: string;
}) => (
  <svg
    className={className}
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.62 1.22083L6.81667 5.02416C6.3675 5.47333 5.6325 5.47333 5.18334 5.02416L1.38 1.22083"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconHealthy = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05003 10.8701L8.66003 12.4801L12.96 8.18006M8.49003 1.23006L3.50003 3.11006C2.35003 3.54006 1.41003 4.90006 1.41003 6.12006V13.5501C1.41003 14.7301 2.19003 16.2801 3.14003 16.9901L7.44003 20.2001C8.85003 21.2601 11.17 21.2601 12.58 20.2001L16.88 16.9901C17.83 16.2801 18.61 14.7301 18.61 13.5501V6.12006C18.61 4.89006 17.67 3.53006 16.52 3.10006L11.53 1.23006C10.68 0.920059 9.32003 0.920059 8.49003 1.23006Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAcceptNewOrdersActive = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.31 13.7L8.81 15.2L12.81 11.2M14 3.02C17.33 3.2 19 4.43 19 9V15C19 19 18 21 13 21H7C2 21 1 19 1 15V9C1 4.44 2.67 3.2 6 3.02M8 5H12C14 5 14 4 14 3C14 1 13 1 12 1H8C7 1 6 1 6 3C6 5 7 5 8 5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSystemRunning = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.9697 22C17.4927 22 21.9697 17.523 21.9697 12C21.9697 6.477 17.4927 2 11.9697 2C6.44673 2 1.96973 6.477 1.96973 12C1.96973 17.523 6.44673 22 11.9697 22Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.73973 10.56C8.73973 8.48 10.2097 7.63 12.0097 8.67L14.9097 10.35C16.7097 11.39 16.7097 13.09 14.9097 14.13L12.0097 15.81C10.2097 16.85 8.73973 16 8.73973 13.92V10.56Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSystemAutoMode = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.56953 12.46L6.51953 15.51"
      stroke={stroke}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5498 12.4902L9.5998 15.5402"
      stroke={stroke}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5303 14H13.5403"
      stroke={stroke}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4697 14H17.4797"
      stroke={stroke}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 15.98V15.96"
      stroke={stroke}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 12.04V12.02"
      stroke={stroke}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22H15C20 22 22 20 22 15V13C22 8 20 6 15 6H9C4 6 2 8 2 13V15C2 20 4 22 9 22Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0105 2L13.0005 3.01C12.9905 3.56 12.5505 4 12.0005 4H11.9705C11.4205 4 10.9805 4.45 10.9805 5C10.9805 5.55 11.4305 6 11.9805 6H12.9805"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSystemTasks = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 11C17 10.4696 17.2107 9.96086 17.5858 9.58579C17.9609 9.21071 18.4696 9 19 9C19.5304 9 20.0391 9.21071 20.4142 9.58579C20.7893 9.96086 21 10.4696 21 11C21 11.5304 20.7893 12.0391 20.4142 12.4142C20.0391 12.7893 19.5304 13 19 13C18.4696 13 17.9609 12.7893 17.5858 12.4142C17.2107 12.0391 17 11.5304 17 11ZM17 11H5M17 3C17 2.46957 17.2107 1.96086 17.5858 1.58579C17.9609 1.21071 18.4696 1 19 1C19.5304 1 20.0391 1.21071 20.4142 1.58579C20.7893 1.96086 21 2.46957 21 3C21 3.53043 20.7893 4.03914 20.4142 4.41421C20.0391 4.78929 19.5304 5 19 5C18.4696 5 17.9609 4.78929 17.5858 4.41421C17.2107 4.03914 17 3.53043 17 3ZM17 3H13C11 3 10 4 10 6V16C10 18 11 19 13 19H17M17 19C17 18.4696 17.2107 17.9609 17.5858 17.5858C17.9609 17.2107 18.4696 17 19 17C19.5304 17 20.0391 17.2107 20.4142 17.5858C20.7893 17.9609 21 18.4696 21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21C18.4696 21 17.9609 20.7893 17.5858 20.4142C17.2107 20.0391 17 19.5304 17 19ZM5 11C5 11.5304 4.78929 12.0391 4.41421 12.4142C4.03914 12.7893 3.53043 13 3 13C2.46957 13 1.96086 12.7893 1.58579 12.4142C1.21071 12.0391 1 11.5304 1 11C1 10.4696 1.21071 9.96086 1.58579 9.58579C1.96086 9.21071 2.46957 9 3 9C3.53043 9 4.03914 9.21071 4.41421 9.58579C4.78929 9.96086 5 10.4696 5 11Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconMachineSpeed = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.20004 8.75C1.06886 9.39622 1 10.0651 1 10.75V13.25H21V10.75C21 10.0651 20.9311 9.39622 20.8 8.75M1.20004 8.75C2.12658 4.18552 6.16208 0.75 11 0.75M1.20004 8.75H4M11 0.75C15.8379 0.75 19.8734 4.18552 20.8 8.75M11 0.75V3.25M20.8 8.75H18M14 13.25L8 7.25"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconOrder = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.17014 6.44L11.0001 11.55L19.7701 6.47M11.0001 20.61V11.54M16.0001 12.24V8.58L6.51014 3.1M8.93014 1.48L3.59014 4.45C2.38014 5.12 1.39014 6.8 1.39014 8.18V13.83C1.39014 15.21 2.38014 16.89 3.59014 17.56L8.93014 20.53C10.0701 21.16 11.9401 21.16 13.0801 20.53L18.4201 17.56C19.6301 16.89 20.6201 15.21 20.6201 13.83V8.18C20.6201 6.8 19.6301 5.12 18.4201 4.45L13.0801 1.48C11.9301 0.84 10.0701 0.84 8.93014 1.48Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDelivery = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11V1H5C2.79 1 1 2.79 1 5V13M14 11C14 12.1 13.1 13 12 13H1M14 11V4H15.84C16.56 4 17.22 4.39 17.58 5.01L19.29 8M1 13V16C1 17.66 2.34 19 4 19H5M21 13V16C21 17.66 19.66 19 18 19H17M21 13H18C17.45 13 17 12.55 17 12V9C17 8.45 17.45 8 18 8H19.29M21 13V11L19.29 8M17 19C17 17.9 16.1 17 15 17M17 19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21C14.4696 21 13.9609 20.7893 13.5858 20.4142C13.2107 20.0391 13 19.5304 13 19M17 19C17 18.4696 16.7893 17.9609 16.4142 17.5858C16.0391 17.2107 15.5304 17 15 17M15 17C13.9 17 13 17.9 13 19M15 17C14.4696 17 13.9609 17.2107 13.5858 17.5858C13.2107 17.9609 13 18.4696 13 19M13 19H9M9 19C9 17.9 8.1 17 7 17M9 19C9 19.5304 8.78929 20.0391 8.41421 20.4142C8.03914 20.7893 7.53043 21 7 21C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19M9 19C9 18.4696 8.78929 17.9609 8.41421 17.5858C8.03914 17.2107 7.53043 17 7 17M7 17C5.9 17 5 17.9 5 19M7 17C6.46957 17 5.96086 17.2107 5.58579 17.5858C5.21071 17.9609 5 18.4696 5 19"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAlert = ({
  fill = "var(--color-primary-80)",
}: {
  fill?: string;
}) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5415 10.5499L3.05552 10.8594L3.05686 10.8571L2.5415 10.5499ZM1.58316 12.1416L1.06914 11.8321L1.06905 11.8322L1.58316 12.1416ZM2.48316 14.5832L2.2908 15.1516L2.29303 15.1523L2.48316 14.5832ZM13.5415 14.5832L13.3532 14.0135L13.3514 14.0142L13.5415 14.5832ZM14.4415 12.1416L14.956 11.8329L14.9555 11.8321L14.4415 12.1416ZM13.4832 10.5499L12.9634 10.8498L12.9691 10.8594L13.4832 10.5499ZM9.5585 1.66664L9.39415 2.24369C9.6135 2.30616 9.84929 2.23887 10.0026 2.07005C10.156 1.90122 10.2003 1.66006 10.1171 1.44771L9.5585 1.66664ZM6.47516 1.66664L5.91653 1.44771C5.83331 1.66006 5.87768 1.90122 6.03102 2.07005C6.18437 2.23887 6.42016 2.30616 6.63951 2.24369L6.47516 1.66664ZM6.24977 16.65L5.82519 17.074L5.82551 17.0743L6.24977 16.65ZM8.0165 0.824898C4.92679 0.824898 2.4165 3.33519 2.4165 6.4249H3.6165C3.6165 3.99794 5.58953 2.0249 8.0165 2.0249V0.824898ZM2.4165 6.4249V8.83323H3.6165V6.4249H2.4165ZM2.4165 8.83323C2.4165 9.01511 2.37547 9.27916 2.29773 9.5592C2.22005 9.83906 2.11906 10.0868 2.02613 10.2427L3.05686 10.8571C3.22226 10.5797 3.35878 10.2232 3.45401 9.88018C3.54919 9.5373 3.6165 9.15969 3.6165 8.83323H2.4165ZM2.02748 10.2404L1.06914 11.8321L2.09718 12.4511L3.05552 10.8594L2.02748 10.2404ZM1.06905 11.8322C0.688388 12.4649 0.609594 13.1733 0.842372 13.802C1.07489 14.4299 1.59521 14.9161 2.2908 15.1516L2.67552 14.0149C2.28778 13.8837 2.06227 13.6407 1.9677 13.3853C1.8734 13.1306 1.88627 12.8016 2.09727 12.4509L1.06905 11.8322ZM2.29303 15.1523C6.0081 16.3935 10.0166 16.3935 13.7316 15.1523L13.3514 14.0142C9.8831 15.1729 6.14156 15.1729 2.6733 14.0142L2.29303 15.1523ZM13.7298 15.1529C15.1054 14.6982 15.7026 13.0772 14.956 11.8329L13.927 12.4503C14.2804 13.0393 13.9943 13.8016 13.3532 14.0136L13.7298 15.1529ZM14.9555 11.8321L13.9972 10.2404L12.9691 10.8594L13.9275 12.4511L14.9555 11.8321ZM14.0029 10.2501C13.9116 10.0918 13.8117 9.84163 13.7347 9.561C13.6576 9.27971 13.6165 9.01529 13.6165 8.83323H12.4165C12.4165 9.15951 12.4838 9.53675 12.5774 9.87838C12.6713 10.2207 12.8048 10.5747 12.9635 10.8497L14.0029 10.2501ZM13.6165 8.83323V6.4249H12.4165V8.83323H13.6165ZM13.6165 6.4249C13.6165 3.34353 11.0979 0.824898 8.0165 0.824898V2.0249C10.4351 2.0249 12.4165 4.00627 12.4165 6.4249H13.6165ZM9.72284 1.08959C8.60767 0.77198 7.42599 0.77198 6.31082 1.08959L6.63951 2.24369C7.53982 1.98728 8.49384 1.98728 9.39415 2.24369L9.72284 1.08959ZM7.0338 1.88556C7.18791 1.49232 7.57054 1.21664 8.01683 1.21664V0.0166382C7.06312 0.0166382 6.24575 0.607623 5.91653 1.44771L7.0338 1.88556ZM8.01683 1.21664C8.46312 1.21664 8.84575 1.49232 8.99986 1.88556L10.1171 1.44771C9.78791 0.607623 8.97054 0.0166382 8.01683 0.0166382V1.21664ZM9.91644 14.8834C9.91644 15.927 9.06007 16.7834 8.01644 16.7834V17.9834C9.72281 17.9834 11.1164 16.5897 11.1164 14.8834H9.91644ZM8.01644 16.7834C7.49909 16.7834 7.01646 16.5682 6.67404 16.2258L5.82551 17.0743C6.38309 17.6319 7.16712 17.9834 8.01644 17.9834V16.7834ZM6.67435 16.2261C6.31815 15.8693 6.11757 15.3861 6.11644 14.882L4.91644 14.8847C4.91829 15.7058 5.24499 16.4929 5.82519 17.074L6.67435 16.2261Z"
      fill={fill}
    />
  </svg>
);

export const IconAlertSuccess = ({
  stroke = "var(--color-green-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.45866 8.99984L7.81699 11.3582L12.542 6.6415M9.00033 17.3332C13.5837 17.3332 17.3337 13.5832 17.3337 8.99984C17.3337 4.4165 13.5837 0.666504 9.00033 0.666504C4.41699 0.666504 0.666992 4.4165 0.666992 8.99984C0.666992 13.5832 4.41699 17.3332 9.00033 17.3332Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconTable = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3125 6.75H5.6875M11.3125 11.25H5.6875M6.25 16.5H10.75C14.5 16.5 16 15 16 11.25V6.75C16 3 14.5 1.5 10.75 1.5H6.25C2.5 1.5 1 3 1 6.75V11.25C1 15 2.5 16.5 6.25 16.5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBoard = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.875 14.925V3.075C7.875 1.95 7.395 1.5 6.2025 1.5H3.1725C1.98 1.5 1.5 1.95 1.5 3.075V14.925C1.5 16.05 1.98 16.5 3.1725 16.5H6.2025C7.395 16.5 7.875 16.05 7.875 14.925ZM16.5 9.675V3.075C16.5 1.95 16.02 1.5 14.8275 1.5H11.7975C10.605 1.5 10.125 1.95 10.125 3.075V9.675C10.125 10.8 10.605 11.25 11.7975 11.25H14.8275C16.02 11.25 16.5 10.8 16.5 9.675Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPlus = ({
  stroke = "var(--color-white)",
}: {
  stroke?: string;
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 6H10.5M6 10.5V1.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconMinus = ({
  stroke = "var(--color-white)",
}: {
  stroke?: string;
}) => (
  <svg
    width="11"
    height="2"
    viewBox="0 0 11 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1H10"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconStoreBasket = ({
  stroke = "var(--color-white)",
}: {
  stroke?: string;
}) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 1.5H2.805C3.615 1.5 4.2525 2.1975 4.185 3L3.5625 10.47C3.53819 10.7594 3.57426 11.0507 3.66843 11.3254C3.76259 11.6001 3.91279 11.8523 4.1095 12.066C4.30622 12.2796 4.54517 12.45 4.81121 12.5665C5.07725 12.683 5.36459 12.7429 5.655 12.7425H13.6425C14.7225 12.7425 15.6675 11.8575 15.75 10.785L16.155 5.16C16.245 3.915 15.3 2.9025 14.0475 2.9025H4.365M6.75 6H15.75M12.1875 16.5C12.4361 16.5 12.6746 16.4012 12.8504 16.2254C13.0262 16.0496 13.125 15.8111 13.125 15.5625C13.125 15.3139 13.0262 15.0754 12.8504 14.8996C12.6746 14.7238 12.4361 14.625 12.1875 14.625C11.9389 14.625 11.7004 14.7238 11.5246 14.8996C11.3488 15.0754 11.25 15.3139 11.25 15.5625C11.25 15.8111 11.3488 16.0496 11.5246 16.2254C11.7004 16.4012 11.9389 16.5 12.1875 16.5ZM6.1875 16.5C6.43614 16.5 6.6746 16.4012 6.85041 16.2254C7.02623 16.0496 7.125 15.8111 7.125 15.5625C7.125 15.3139 7.02623 15.0754 6.85041 14.8996C6.6746 14.7238 6.43614 14.625 6.1875 14.625C5.93886 14.625 5.7004 14.7238 5.52459 14.8996C5.34877 15.0754 5.25 15.3139 5.25 15.5625C5.25 15.8111 5.34877 16.0496 5.52459 16.2254C5.7004 16.4012 5.93886 16.5 6.1875 16.5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLibrary = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 8.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V5.25C1.5 2.25 2.25 1.5 5.25 1.5H6.375C7.5 1.5 7.7475 1.83 8.175 2.4L9.3 3.9C9.585 4.275 9.75 4.5 10.5 4.5H12.75C15.75 4.5 16.5 5.25 16.5 8.25Z"
      stroke="#24262B"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const IconStream = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.5C15.945 9.2475 16.5 7.6875 16.5 6C16.5 4.3125 15.945 2.7525 15 1.5M3 1.5C2.055 2.7525 1.5 4.3125 1.5 6C1.5 7.6875 2.055 9.2475 3 10.5M12.6 8.7C13.1625 7.95 13.5 7.0125 13.5 6C13.5 4.9875 13.1625 4.05 12.6 3.3M5.4 3.3C4.8375 4.05 4.5 4.9875 4.5 6C4.5 7.0125 4.8375 7.95 5.4 8.7M9 7.5C9.39782 7.5 9.77936 7.34196 10.0607 7.06066C10.342 6.77936 10.5 6.39782 10.5 6C10.5 5.60218 10.342 5.22064 10.0607 4.93934C9.77936 4.65804 9.39782 4.5 9 4.5C8.60218 4.5 8.22064 4.65804 7.93934 4.93934C7.65804 5.22064 7.5 5.60218 7.5 6C7.5 6.39782 7.65804 6.77936 7.93934 7.06066C8.22064 7.34196 8.60218 7.5 9 7.5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrow = ({
  stroke = "var(--color-white)",
  className = "",
}: {
  stroke?: string;
  className?: string;
}) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.57 0.929993L1.5 6.99999L7.57 13.07M18.5 6.99999H1.67"
      stroke={stroke}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconManualControlAction = ({
  stroke = "var(--color-gray-80)",
  className = "",
}: {
  stroke?: string;
  className?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconsax/Linear/setting3" clipPath="url(#clip0_2438_19301)">
      <path
        id="Vector"
        d="M11.6775 13.875V10.95M11.6775 5.5875V4.125M11.6775 5.5875C11.9336 5.5875 12.1871 5.63794 12.4237 5.73593C12.6603 5.83393 12.8753 5.97757 13.0564 6.15864C13.2374 6.33972 13.3811 6.55468 13.4791 6.79127C13.5771 7.02785 13.6275 7.28142 13.6275 7.5375C13.6275 7.79358 13.5771 8.04715 13.4791 8.28373C13.3811 8.52032 13.2374 8.73528 13.0564 8.91636C12.8753 9.09743 12.6603 9.24107 12.4237 9.33906C12.1871 9.43706 11.9336 9.4875 11.6775 9.4875C11.1603 9.4875 10.6643 9.28205 10.2986 8.91636C9.93295 8.55066 9.7275 8.05467 9.7275 7.5375C9.7275 7.02033 9.93295 6.52434 10.2986 6.15864C10.6643 5.79295 11.1603 5.5875 11.6775 5.5875ZM6.3225 13.875V12.4125M6.3225 12.4125C6.57858 12.4125 6.83215 12.3621 7.06873 12.2641C7.30532 12.1661 7.52028 12.0224 7.70136 11.8414C7.88243 11.6603 8.02607 11.4453 8.12406 11.2087C8.22206 10.9721 8.2725 10.7186 8.2725 10.4625C8.2725 10.2064 8.22206 9.95285 8.12406 9.71627C8.02607 9.47968 7.88243 9.26472 7.70136 9.08364C7.52028 8.90257 7.30532 8.75893 7.06873 8.66094C6.83215 8.56294 6.57858 8.5125 6.3225 8.5125C5.80533 8.5125 5.30934 8.71795 4.94364 9.08364C4.57795 9.44934 4.3725 9.94533 4.3725 10.4625C4.3725 10.9797 4.57795 11.4757 4.94364 11.8414C5.30934 12.2071 5.80533 12.4125 6.3225 12.4125ZM6.3225 7.05V4.125M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2438_19301">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconKeyUsageOpen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_3704_22007)">
      <path
        d="M9.75 8.25L15.9 2.1M16.5 5.1V1.5H12.9M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75"
        stroke="var(--stroke)"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3704_22007">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconCheck = ({ stroke = "#595E6A" }: { stroke?: string }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Linear/tick">
      <path
        id="Vector"
        d="M3 9.19971L6.99529 13.1372L15 5.26221"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const IconQuestionHeader = ({
  stroke = "#7F8493",
}: {
  stroke?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Linear/question_circle" clipPath="url(#clip0_5098_4361)">
      <path
        id="Vector"
        d="M8.99988 9.675V9.5175C8.99988 9.0075 9.31488 8.7375 9.62988 8.52C9.93738 8.31 10.2449 8.04 10.2449 7.545C10.2449 6.855 9.68988 6.3 8.99988 6.3C8.30988 6.3 7.75488 6.855 7.75488 7.545M8.99613 11.4675H9.00363M9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5098_4361">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconWarranty = ({ stroke = "#7F8493" }: { stroke?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/linear/info-circle">
      <g id="info-circle">
        <path
          id="Vector"
          d="M9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5Z"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9 12L9 8.25"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M9.00409 6L8.99735 6"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const IconSupport = ({ stroke = "#7F8493" }: { stroke?: string }) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3 7.92857C2.3 4.37817 4.08125 1.5 8 1.5C11.9188 1.5 13.7 4.37817 13.7 7.92857M2.65625 12.2143C3.0125 13.4048 4.08125 15.6429 6.93125 15.0714M4.4375 7.92857H3.0125C1.83199 7.92857 0.875 8.88796 0.875 10.0714C0.875 11.2549 1.83199 12.2143 3.0125 12.2143H4.4375V7.92857ZM11.5625 12.2143H12.9875C14.168 12.2143 15.125 11.2549 15.125 10.0714C15.125 8.88796 14.168 7.92857 12.9875 7.92857H11.5625V12.2143ZM8 16.5C7.21299 16.5 6.575 15.8604 6.575 15.0714C6.575 14.2825 7.21299 13.6429 8 13.6429C8.78701 13.6429 9.425 14.2825 9.425 15.0714C9.425 15.8604 8.78701 16.5 8 16.5Z"
      stroke={stroke}
      strokeWidth="1.2"
    />
  </svg>
);

export const IconLogout = ({ stroke = "#DC2626" }: { stroke?: string }) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.675 4.66993C6.9075 1.96993 8.295 0.867432 11.3325 0.867432H11.43C14.7825 0.867432 16.125 2.20993 16.125 5.56243V10.4524C16.125 13.8049 14.7825 15.1474 11.43 15.1474H11.3325C8.3175 15.1474 6.93 14.0599 6.6825 11.4049M1.5 7.99993H11.16M9.4875 5.48743L12 7.99993L9.4875 10.5124"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLanguage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6 2.25H6.75C5.2875 6.63 5.2875 11.37 6.75 15.75H6M11.25 2.25C12.7125 6.63 12.7125 11.37 11.25 15.75M2.25 12V11.25C6.63 12.7125 11.37 12.7125 15.75 11.25V12M2.25 6.75C6.63 5.2875 11.37 5.2875 15.75 6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
      stroke="var(--stroke)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconUserSettings = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M14.025 12.1875C14.25 12.9975 14.88 13.6275 15.69 13.8525M2.5575 16.5C2.5575 13.5975 5.44502 11.25 9.00002 11.25C9.78002 11.25 10.53 11.3625 11.2275 11.5725M12.75 5.25C12.75 7.32107 11.0711 9 9.00002 9C6.92895 9 5.25002 7.32107 5.25002 5.25C5.25002 3.17893 6.92895 1.5 9.00002 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25ZM14.4075 11.805L11.7525 14.46C11.6475 14.565 11.55 14.76 11.5275 14.9025L11.385 15.915C11.3325 16.2825 11.5875 16.5375 11.955 16.485L12.9675 16.3425C13.11 16.32 13.3125 16.2225 13.41 16.1175L16.065 13.4625C16.5225 13.005 16.74 12.4725 16.065 11.7975C15.3975 11.13 14.865 11.3475 14.4075 11.805Z"
      stroke="var(--stroke)"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconExport = ({
  stroke = "var(--color-white)",
}: {
  stroke?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3304 5.675C14.0304 5.9075 15.1329 7.295 15.1329 10.3325V10.43C15.1329 13.7825 13.7904 15.125 10.4379 15.125H5.55535C2.20285 15.125 0.860352 13.7825 0.860352 10.43V10.3325C0.860352 7.3175 1.94785 5.93 4.60285 5.6825M8.00035 10.25V1.715M10.5129 3.3875L8.00035 0.875L5.48785 3.3875"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconUsersView = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M12.3066 3.00005C13.7616 3.00005 14.9316 4.17755 14.9316 5.62505C14.9316 7.04255 13.8066 8.19755 12.4041 8.25005C12.3393 8.24255 12.2738 8.24255 12.2091 8.25005M13.7541 15.0001C14.2941 14.8876 14.8041 14.6701 15.2241 14.3476C16.3941 13.4701 16.3941 12.0226 15.2241 11.1451C14.8116 10.8301 14.3091 10.6201 13.7766 10.5001M6.86906 8.15255C6.79406 8.14505 6.70406 8.14505 6.62156 8.15255C5.76072 8.12333 4.94504 7.76018 4.34728 7.14002C3.74953 6.51987 3.41662 5.69139 3.41906 4.83005C3.41906 2.99255 4.90406 1.50005 6.74906 1.50005C7.63124 1.48414 8.4836 1.81932 9.11865 2.43186C9.75369 3.0444 10.1194 3.88413 10.1353 4.7663C10.1512 5.64848 9.81604 6.50085 9.2035 7.13589C8.59096 7.77094 7.75124 8.13664 6.86906 8.15255ZM3.11906 10.9201C1.30406 12.1351 1.30406 14.1151 3.11906 15.3226C5.18156 16.7026 8.56406 16.7026 10.6266 15.3226C12.4416 14.1076 12.4416 12.1276 10.6266 10.9201C8.57156 9.54755 5.18906 9.54755 3.11906 10.9201Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSettings = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3346 5.41667H13.3346M5.0013 5.41667H1.66797M18.3346 14.5833H15.0013M6.66797 14.5833H1.66797M8.33464 8.33333C8.71766 8.33333 9.09693 8.25789 9.4508 8.11132C9.80466 7.96474 10.1262 7.7499 10.397 7.47906C10.6679 7.20822 10.8827 6.88669 11.0293 6.53283C11.1759 6.17896 11.2513 5.79969 11.2513 5.41667C11.2513 5.03364 11.1759 4.65437 11.0293 4.30051C10.8827 3.94664 10.6679 3.62511 10.397 3.35427C10.1262 3.08343 9.80466 2.86859 9.4508 2.72202C9.09693 2.57544 8.71766 2.5 8.33464 2.5C7.56109 2.5 6.81922 2.80729 6.27224 3.35427C5.72526 3.90125 5.41797 4.64312 5.41797 5.41667C5.41797 6.19021 5.72526 6.93208 6.27224 7.47906C6.81922 8.02604 7.56109 8.33333 8.33464 8.33333ZM11.668 17.5C12.4415 17.5 13.1834 17.1927 13.7304 16.6457C14.2773 16.0987 14.5846 15.3569 14.5846 14.5833C14.5846 13.8098 14.2773 13.0679 13.7304 12.5209C13.1834 11.974 12.4415 11.6667 11.668 11.6667C10.8944 11.6667 10.1526 11.974 9.60557 12.5209C9.05859 13.0679 8.7513 13.8098 8.7513 14.5833C8.7513 15.3569 9.05859 16.0987 9.60557 16.6457C10.1526 17.1927 10.8944 17.5 11.668 17.5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPermissionsView = ({
  stroke = "var(--color-gray-80)",
}: {
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_6818_14171)">
      <path
        d="M5.16944 13.1177L6.89444 14.8427M14.8444 11.1977C14.1121 11.9283 13.1941 12.445 12.1896 12.6922C11.1851 12.9393 10.1322 12.9075 9.14444 12.6002L5.61194 16.1252C5.35694 16.3877 4.85444 16.5452 4.49444 16.4927L2.85944 16.2677C2.31944 16.1927 1.81694 15.6827 1.73444 15.1427L1.50944 13.5077C1.45694 13.1477 1.62944 12.6452 1.87694 12.3902L5.40194 8.86523C4.80194 6.91523 5.26694 4.70273 6.81194 3.16523C9.02444 0.952734 12.6169 0.952734 14.8369 3.16523C17.0569 5.37773 17.0569 8.98523 14.8444 11.1977ZM10.8769 8.25023C11.1753 8.25023 11.4615 8.13171 11.6724 7.92073C11.8834 7.70975 12.0019 7.4236 12.0019 7.12523C12.0019 6.82687 11.8834 6.54072 11.6724 6.32974C11.4615 6.11876 11.1753 6.00023 10.8769 6.00023C10.5786 6.00023 10.2924 6.11876 10.0814 6.32974C9.87047 6.54072 9.75194 6.82687 9.75194 7.12523C9.75194 7.4236 9.87047 7.70975 10.0814 7.92073C10.2924 8.13171 10.5786 8.25023 10.8769 8.25023Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6818_14171">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconTimes = ({
  stroke = "var(--color-red-70)",
}: {
  stroke?: string;
}) => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="xmark " clipPath="url(#clip0_4887_20990)">
      <path
        id="Vector"
        d="M9.59985 4.91235C9.96606 4.54614 9.96606 3.95142 9.59985 3.58521C9.23364 3.21899 8.63892 3.21899 8.27271 3.58521L5.18774 6.6731L2.09985 3.58813C1.73364 3.22192 1.13892 3.22192 0.772705 3.58813C0.406494 3.95435 0.406494 4.54907 0.772705 4.91528L3.8606 8.00024L0.775635 11.0881C0.409424 11.4543 0.409424 12.0491 0.775635 12.4153C1.14185 12.7815 1.73657 12.7815 2.10278 12.4153L5.18774 9.32739L8.27563 12.4124C8.64185 12.7786 9.23657 12.7786 9.60278 12.4124C9.96899 12.0461 9.96899 11.4514 9.60278 11.0852L6.51489 8.00024L9.59985 4.91235Z"
        fill={stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_4887_20990">
        <rect
          width="9.375"
          height="15"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconUser = ({
  stroke = "var(--color-gray)",
}: {
  stroke?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1583 18.3334C17.1583 15.1084 13.95 12.5001 10 12.5001C6.05001 12.5001 2.84167 15.1084 2.84167 18.3334M10 10.0001C11.1051 10.0001 12.1649 9.56109 12.9463 8.77969C13.7277 7.99829 14.1667 6.93848 14.1667 5.83341C14.1667 4.72835 13.7277 3.66854 12.9463 2.88714C12.1649 2.10573 11.1051 1.66675 10 1.66675C8.89494 1.66675 7.83513 2.10573 7.05373 2.88714C6.27233 3.66854 5.83334 4.72835 5.83334 5.83341C5.83334 6.93848 6.27233 7.99829 7.05373 8.77969C7.83513 9.56109 8.89494 10.0001 10 10.0001Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAlertTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 21.6182V13.5543M20 27.5952V27.6661M30.0799 34.3821H9.92012C7.16641 34.3821 4.84253 32.5417 4.11138 30.0238C3.79927 28.949 4.18277 27.8295 4.76935 26.8763L14.8492 8.4964C17.2108 4.65875 22.7892 4.65875 25.1508 8.49641L35.2306 26.8763C35.8172 27.8295 36.2007 28.949 35.8886 30.0238C35.1575 32.5417 32.8336 34.3821 30.0799 34.3821Z"
      stroke="#DC2626"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconEdit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clip-path="url(#clip0_8152_9719)">
      <path
        d="M8.25 1.49995H6.75C3 1.49995 1.5 2.99995 1.5 6.74995V11.2499C1.5 14.9999 3 16.4999 6.75 16.4999H11.25C15 16.4999 16.5 14.9999 16.5 11.2499V9.74995M11.1825 3.11245C11.4312 3.99555 11.9025 4.79999 12.5512 5.44873C13.2 6.09746 14.0044 6.56875 14.8875 6.81745M12.03 2.26495L6.12 8.17495C5.895 8.39995 5.67 8.84245 5.625 9.16495L5.3025 11.4224C5.1825 12.2399 5.76 12.8099 6.5775 12.6974L8.835 12.3749C9.15 12.3299 9.5925 12.1049 9.825 11.8799L15.735 5.96995C16.755 4.94995 17.235 3.76495 15.735 2.26495C14.235 0.764945 13.05 1.24495 12.03 2.26495Z"
        stroke="#7F8493"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8152_9719">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
